/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateRoleGrant} from '../models/UpdateRoleGrant';
import type {UpdateRoleGrantsResult} from '../models/UpdateRoleGrantsResult';

export interface BulkDischargeRoleGrants$Request {
    updateRoleGrant: UpdateRoleGrant;
    reason?: string;
}

export interface BulkDischargeRoleGrants$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeRoleGrantsRequest = createAction<PayloadData<void, BulkDischargeRoleGrants$Request>>('BULK_DISCHARGE_ROLE_GRANTS__BULK_DISCHARGE_ROLE_GRANTS__REQUEST');
export const bulkDischargeRoleGrantsSuccess = createAction<PayloadData<string, BulkDischargeRoleGrants$Request>>('BULK_DISCHARGE_ROLE_GRANTS__BULK_DISCHARGE_ROLE_GRANTS__SUCCESS');
export const bulkDischargeRoleGrantsFailure = createAction<PayloadData<Error, BulkDischargeRoleGrants$Request, true>>('BULK_DISCHARGE_ROLE_GRANTS__BULK_DISCHARGE_ROLE_GRANTS__FAILURE');

export const bulkDischargeRoleGrantsActions = [
    bulkDischargeRoleGrantsRequest,
    bulkDischargeRoleGrantsSuccess,
    bulkDischargeRoleGrantsFailure
] as const;

/**
 * @param {UpdateRoleGrant} meta.updateRoleGrant
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeRoleGrants = (meta: BulkDischargeRoleGrants$Request, config?: BulkDischargeRoleGrants$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkDischargeRoleGrantsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/roles/discharge-grants`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateRoleGrant,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface BulkDischargeRoleGrantsProgress$Request {
    id: string;
}

export interface BulkDischargeRoleGrantsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeRoleGrantsProgressRequest = createAction<PayloadData<void, BulkDischargeRoleGrantsProgress$Request>>('BULK_DISCHARGE_ROLE_GRANTS__BULK_DISCHARGE_ROLE_GRANTS_PROGRESS__REQUEST');
export const bulkDischargeRoleGrantsProgressSuccess = createAction<PayloadData<BulkProgress, BulkDischargeRoleGrantsProgress$Request>>('BULK_DISCHARGE_ROLE_GRANTS__BULK_DISCHARGE_ROLE_GRANTS_PROGRESS__SUCCESS');
export const bulkDischargeRoleGrantsProgressFailure = createAction<PayloadData<Error, BulkDischargeRoleGrantsProgress$Request, true>>('BULK_DISCHARGE_ROLE_GRANTS__BULK_DISCHARGE_ROLE_GRANTS_PROGRESS__FAILURE');

export const bulkDischargeRoleGrantsProgressActions = [
    bulkDischargeRoleGrantsProgressRequest,
    bulkDischargeRoleGrantsProgressSuccess,
    bulkDischargeRoleGrantsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeRoleGrantsProgress = (meta: BulkDischargeRoleGrantsProgress$Request, config?: BulkDischargeRoleGrantsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkDischargeRoleGrantsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/roles/discharge-grants/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeRoleGrantsResult$Request {
    id: string;
}

export interface GetDischargeRoleGrantsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeRoleGrantsResultRequest = createAction<PayloadData<void, GetDischargeRoleGrantsResult$Request>>('BULK_DISCHARGE_ROLE_GRANTS__GET_DISCHARGE_ROLE_GRANTS_RESULT__REQUEST');
export const getDischargeRoleGrantsResultSuccess = createAction<PayloadData<UpdateRoleGrantsResult, GetDischargeRoleGrantsResult$Request>>('BULK_DISCHARGE_ROLE_GRANTS__GET_DISCHARGE_ROLE_GRANTS_RESULT__SUCCESS');
export const getDischargeRoleGrantsResultFailure = createAction<PayloadData<Error, GetDischargeRoleGrantsResult$Request, true>>('BULK_DISCHARGE_ROLE_GRANTS__GET_DISCHARGE_ROLE_GRANTS_RESULT__FAILURE');

export const getDischargeRoleGrantsResultActions = [
    getDischargeRoleGrantsResultRequest,
    getDischargeRoleGrantsResultSuccess,
    getDischargeRoleGrantsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeRoleGrantsResult = (meta: GetDischargeRoleGrantsResult$Request, config?: GetDischargeRoleGrantsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeRoleGrantsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/roles/discharge-grants`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

